__turbopack_context__.v({
  "button": "button-module__zxu6dG__button",
  "danger": "button-module__zxu6dG__danger",
  "dangerGhost": "button-module__zxu6dG__dangerGhost",
  "dangerSecondary": "button-module__zxu6dG__dangerSecondary",
  "ghost": "button-module__zxu6dG__ghost",
  "lg": "button-module__zxu6dG__lg",
  "primary": "button-module__zxu6dG__primary",
  "secondary": "button-module__zxu6dG__secondary",
  "sm": "button-module__zxu6dG__sm",
});
